export const getTimeZoneName = () =>
  Intl.DateTimeFormat()
    .resolvedOptions()
    .timeZone.replace('_', ' ');

export const getTimeZoneAbbreviation = () =>
  new Date()
    .toLocaleTimeString('en-us', { timeZoneName: 'short' })
    .split(' ')[2];
